import React, { useEffect, useState } from 'react'
import categoryone from '../../assets/images/category.png'
import categorytwo from '../../assets/images/categorytwo.png'
import categorythree from '../../assets/images/categorythree.png'
import categoryfour from '../../assets/images/categoryfour.png'
import { Link, useNavigate, useParams } from 'react-router-dom'
import { Button, Form } from 'react-bootstrap'
import { FaRegSquarePlus } from "react-icons/fa6";
import CreateCategory from './CreateCategory'
import * as yup from 'yup';
import { useFormik } from 'formik';
import toast from 'react-hot-toast'
import { createCategory, deleteCategory, editCategory, getCategoryListing, getCategoryListingPaginate, statusUpdateCategory } from '../../api/context/category'
import imageToBase64 from 'image-to-base64/browser';
import moment from 'moment';
import { BiSolidEditAlt } from "react-icons/bi";
import { MdDelete, MdOutlineKeyboardArrowLeft, MdOutlineKeyboardArrowRight } from "react-icons/md";
import CustomisedModal from '../../components/Modal/CustomisedModal'
import { checkUserPermissions } from '../../helpers/permission'
import ReactPaginate from 'react-paginate';
import Loader from '../../components/loader/loader'


const Categories = () => {

    const navigate = useNavigate();

    const [show, setShow] = useState(false);


    const handleShow = () => setShow(true);

    const [loading, setLoading] = useState(false);

    const [update, setUpdate] = useState(false);
    const [category, setCategory] = useState([]);
    // Inside your component
    const [selectedCategory, setSelectedCategory] = useState(null);
    const [modal, setModal] = useState(false);
    const [deletingId, setDeletingId] = useState("");
    const [dataCount, setDataCount] = useState();
    const [currentPage, setCurrentPage] = useState(0);
    const itemsPerPage = 8;

    const toggleModal = () => {
        setModal(!modal);
    };

    const handleClose = () => {
        formik.resetForm();
        setShow(false);
        setSelectedCategory(null);
    };

    const validationSchema = yup.object().shape({
        title: yup
            .string('')
            .trim()
            .required('Name is required'),
        desc: yup
            .string('')
            .trim()
            .required('Description is required'),
        img: selectedCategory?.id ? yup.string().nullable() : yup.string().required('Image is required'),
        isActive: yup
            .boolean()
            .required('isActive is required'),
    });

    const formik = useFormik({
        initialValues: {
            subCategoryId: '',
            title: '',
            desc: '',
            img: '',
            img_view: '',
            isActive: true
        },
        validationSchema: validationSchema,
        onSubmit: async (values, { resetForm }) => {
            setLoading(true);
            if (values.img == '') {
                delete values.img;
            }
            delete values.img_view;
            if (selectedCategory?.id) {
                editCategory(values)((response) => {
                    if (response && response?.data?.statusCode == 200) {
                        resetForm();
                        toast.success("Category Updated Successfully")
                        handleClose();
                        setUpdate(!update);
                        setLoading(false);
                        setSelectedCategory(null);
                    } else {
                        toast.error(response?.data?.message);
                        setLoading(false);
                    }
                })
            } else {
                createCategory(values)((response) => {
                    if (response && response?.data?.statusCode == 200) {
                        resetForm();
                        toast.success("Category Created Successfully")
                        handleClose();
                        setUpdate(!update);
                        setLoading(false);
                        setSelectedCategory(null);
                    } else {
                        toast.error(response?.data?.message);
                        setLoading(false);
                    }
                })
            }
        },
    });



    const handleImageChange = async (e) => {
        const file = e?.target?.files[0];
        const maxSizeInBytes = 2 * 1024 * 1024;
        const validImageTypes = ['image/jpeg', 'image/png', 'image/gif'];

        if (file?.size > maxSizeInBytes) {
            toast.error("File size exceeds 2 MB limit", 'error')
            e.target.value = null;
            return;
        }

        // if (!validImageTypes.includes(file?.type)) {
        //     toast.error("Only jpg/jpeg and png files are allowed!");
        //     e.target.value = null;
        //     return;
        // }

        const response = await imageToBase64(URL.createObjectURL(file));
        formik.setValues({
            ...formik.values,
            img: response,
            img_view: 'data:image/jpeg;base64,' + response,
        });
    }

    const getAllCategories = (page, limit) => {
        getCategoryListingPaginate({ page, limit })((response) => {
            if (response?.statusCode == 200) {
                setCategory(response?.data?.subcategories);
                console.log(response?.data?.subcategories, "response?.data?.subcategories")
                setDataCount(response?.data?.totalCount)
                setLoading(false)
            } else {
                setLoading(false)
                // Handle error condition
            }
        });
    };

    const handlePageChange = (selectedPage) => {
        getAllCategories(selectedPage.selected + 1, itemsPerPage)
        setCurrentPage(selectedPage.selected);
    };


    const handleEditClick = (category) => {
        setSelectedCategory(category);
        formik.setValues({
            ...formik.values,
            subCategoryId: String(category?.id ?? ''),
            title: category?.title ?? '',
            desc: category?.description ?? '',
            // img: category?.img ?? '',
            img_view: category?.img ?? '',
            isActive: category?.isActive ?? true
        });
        setShow(true);
    };

    const handleConfirm = (deletingId) => {
        setModal(!modal);
        setDeletingId(deletingId);
    }

    const statusActive = (id) => {
        statusUpdateCategory(id)((response) => {
            if (response?.data?.statusCode == 200) {
                setUpdate(!update);
                // toast.success(response?.data?.message)
            } else {
                // toast.error(response?.data?.message);
            }
        });

    }

    const deleteCategories = (id) => {
        deleteCategory(id)((response) => {
            if (response?.data?.statusCode == 200) {
                setUpdate(!update);
                setModal(!modal);
                toast.success("Category deleted successfully")
            } else {
                toast.error(response?.data?.message);
            }
        });

    }

    useEffect(() => {
        setLoading(true);
        getAllCategories(1, itemsPerPage)
    }, [update]);



    return (
        <>
            <div>
                <div className="row">
                    <div className="col-12">

                        <div className="d-flex justify-content-between align-items-stretch mb-3 px-0">
                            <div className="d-flex align-items-center"> 
                                <h3 className="mb-0  fw-bolder">Categories</h3>
                            </div>


                            {checkUserPermissions('manage_category') ? (
                                <div className="d-flex align-items-center pe-4"> {/* Right-aligned container */}
                                    <div className=' shadow-none d-flex align-items-center'>
                                      
                                        <Button
                                            className='request_btn ms-2'
                                            onClick={handleShow}
                                        >
                                            <FaRegSquarePlus className='icon' />
                                            Add New Category
                                        </Button>
                                    </div>
                                </div>
                            ) : null}
                        </div>


                        <div className='d_grid_wrapper'>
                            {loading ? (
                                <div style={{ height: '60vh' }}>
                                    <Loader />
                                </div>
                            ) : (
                                category?.map((data, index) => (
                                    <div className='card_wrapper shadow-sm' style={{
                                        border: "1px solid #d1d1d1" // light black/gray border
                                    }} key={index}>
                                        {checkUserPermissions('manage_category') ?
                                            <div className='icon_flex_wrapper'>
                                                <div className='icon_wrapper' onClick={() => handleEditClick(data)}>
                                                    <BiSolidEditAlt className='icon' />
                                                </div>
                                                <div className='icon_wrapper' onClick={() => handleConfirm(data?.id)} >
                                                    <MdDelete className='icon' />
                                                </div>
                                            </div>
                                            :
                                            <></>
                                        }
                                        <div className='card_img_wrapper'>
                                            <img src={data?.img} className='card_img_sub img-fluid' alt={data?.title} />
                                        </div>
                                        <div className='card_content_wrapper'>
                                            <div className='title_wrap'>
                                                <h3>{data?.title}</h3>
                                                {checkUserPermissions('view_sub_category') ?
                                                    <div className='view_btn' onClick={() => navigate('/sub-categories/' + data?.id, { state: { data: data } })}>View Sub- Category</div>
                                                    :
                                                    <></>
                                                }
                                            </div>
                                            <div className='contents'>
                                                <p>{data?.description} </p>
                                            </div>
                                            <div className='created_on'>
                                                <h5>Created on</h5>
                                                <h5>{moment(data?.created_date).format("DD/MM/YYYY")}</h5>
                                            </div>
                                            {checkUserPermissions('manage_category') ?
                                                <div className='status_wrap'>
                                                    <div className='title'>Status</div>
                                                    <Form.Check
                                                        type="switch"
                                                        id={`custom-switch-${index}`}
                                                        checked={data?.isActive}
                                                        onChange={() => statusActive(data?.id)}
                                                        role='button'
                                                    />

                                                </div>
                                                :
                                                <></>
                                            }
                                        </div>
                                    </div>
                                ))
                            )}


                        </div>

                        {category?.length > 0 && Math.ceil(dataCount / itemsPerPage) > 1 && (
                            <ReactPaginate
                                pageCount={Math.ceil(dataCount / itemsPerPage)}
                                previousLabel={<MdOutlineKeyboardArrowLeft fontSize={24} color='#CECECE' />}
                                nextLabel={<MdOutlineKeyboardArrowRight fontSize={24} color='#CECECE' />}
                                onPageChange={handlePageChange}
                                containerClassName="pagination"
                                activeClassName="active"
                                pageClassName="page-item"
                                pageLinkClassName="page-link"
                                previousClassName="page-item"
                                previousLinkClassName="page-link"
                                nextClassName="page-item"
                                nextLinkClassName="page-link"
                                breakClassName="page-item"
                                breakLinkClassName="page-link"
                                disabledClassName="disabled"
                            />
                        )}
                    </div>
                    <CreateCategory show={show} handleClose={handleClose} handleShow={handleShow} formik={formik} handleImageChange={handleImageChange} selectedCategory={selectedCategory} loading={loading} />
                    <CustomisedModal
                        isOpen={modal}
                        customClass={"policy_modal"}
                        toggle={toggleModal}
                    >
                        <h5>
                            Are you sure you want to remove this item?
                        </h5>
                        <div className="policy_Agree">
                            <Button
                                onClick={() => {
                                    setModal(!modal);
                                }}
                                size="lg"
                                className='btn_cancel'
                            >
                                Cancel
                            </Button>
                            <Button
                                size="lg"
                                className='btn'
                                onClick={() => deleteCategories(deletingId)}
                            >
                                Remove
                            </Button>
                        </div>
                    </CustomisedModal>
                </div>
            </div>
        </>
    )
}

export default Categories